/**
 * Debug Variant Picker - Advanced debugging tool
 * This script will help identify exactly what's happening with variant selection
 */

(function() {
  'use strict';
  
  console.log('Debug Variant Picker: Starting advanced debugging');
  
  // Monitor all form submissions
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form && form.action && form.action.includes('/cart/add')) {
      console.log('Cart form submission detected');
      console.log('Form action:', form.action);
      
      // Get all form data
      const formData = new FormData(form);
      console.log('Form data entries:');
      for (let [key, value] of formData.entries()) {
        console.log(`  ${key}: ${value}`);
      }
      
      // Check variant picker state
      const variantPicker = form.closest('product-form-component')?.querySelector('variant-picker');
      if (variantPicker) {
        console.log('Variant picker found');
        
        // Check all inputs in the picker
        const allInputs = variantPicker.querySelectorAll('input, select');
        console.log('All picker inputs:');
        allInputs.forEach((input, index) => {
          console.log(`  Input ${index}:`, {
            type: input.type,
            name: input.name,
            value: input.value,
            checked: input.checked,
            selected: input.selected,
            variantId: input.dataset.variantId,
            optionValueId: input.dataset.optionValueId
          });
        });
        
        // Check selected options
        const selectedInputs = variantPicker.querySelectorAll('input:checked, select option:selected');
        console.log('Selected options:');
        selectedInputs.forEach((input, index) => {
          console.log(`  Selected ${index}:`, {
            type: input.type,
            value: input.value,
            variantId: input.dataset.variantId,
            optionValueId: input.dataset.optionValueId
          });
        });
      } else {
        console.log('No variant picker found in form');
      }
      
      // Check variant ID input
      const variantIdInput = form.querySelector('input[name="id"]');
      if (variantIdInput) {
        console.log('Variant ID input:', {
          value: variantIdInput.value,
          name: variantIdInput.name,
          type: variantIdInput.type
        });
      } else {
        console.log('No variant ID input found');
      }
    }
  });
  
  // Monitor variant picker changes
  document.addEventListener('change', function(event) {
    if (event.target.closest('variant-picker')) {
      console.log('Variant picker change detected');
      console.log('Target element:', event.target);
      console.log('Target dataset:', event.target.dataset);
      console.log('Target value:', event.target.value);
      console.log('Target checked:', event.target.checked);
      
      // Find the product form
      const productForm = event.target.closest('product-form-component');
      if (productForm) {
        const variantIdInput = productForm.querySelector('input[name="id"]');
        console.log('Variant ID input before update:', variantIdInput?.value);
        
        // Wait a moment for any async updates
        setTimeout(() => {
          console.log('Variant ID input after update:', variantIdInput?.value);
        }, 100);
      }
    }
  });
  
  // Monitor all clicks on variant options
  document.addEventListener('click', function(event) {
    if (event.target.closest('variant-picker')) {
      console.log('Variant picker click detected');
      console.log('Clicked element:', event.target);
      console.log('Is input:', event.target.tagName === 'INPUT');
      console.log('Is label:', event.target.tagName === 'LABEL');
    }
  });
  
  console.log('Debug Variant Picker: Monitoring started');
  
})();
